'use client';

// import { useRouter } from 'next/router';
import { cn } from 'common/utils';
import {
  colorByValue,
  formatCurrency,
  formatPercent,
} from 'common/utils/trading-demo';
import { Button } from 'components/v2/atoms/button';
import {
  PortfolioPositionDetailType,
  PositionTypeEnum,
} from 'service/trading-demo';

interface PortfolioPositionItemProps {
  position: PortfolioPositionDetailType;
  onClick?: (position: PortfolioPositionDetailType) => void;
  className?: string;
}

const PortfolioPositionItem = ({
  position,
  onClick,
  className,
}: PortfolioPositionItemProps) => {
  // const router = useRouter();
  const handleClick = () => {
    if (onClick) {
      onClick(position);
    }
  };

  return (
    <div
      className={cn(
        'flex items-center justify-between overflow-x-auto border-b border-gray-200 px-2 py-3 transition-colors duration-200 hover:bg-gray-50 md:p-4',
        className,
      )}
    >
      <div className="flex items-center gap-2">
        <div
          className={cn(
            'flex size-6 shrink-0 items-center justify-center rounded text-xs font-bold',
            position.position_type === PositionTypeEnum.Long
              ? 'bg-pp-green-subtle text-growth-green'
              : 'bg-[#ef444426] text-pp-error-primary',
          )}
        >
          {position.position_type === PositionTypeEnum.Long ? '買' : '売'}
        </div>
        <div className="flex flex-col">
          <div className="flex items-center gap-2">
            <span className="font-semibold text-pp-text-primary">
              {position.symbol_name}
            </span>
            <span className="text-xs text-pp-text-secondary">
              数量：{position.quantity}
            </span>
          </div>
          {/* {position.position_post &&
            position.position_post.user_name &&
            position.position_post.post_id && (
              <button
                className="mt-0.5 flex items-center gap-1.5 text-xs text-pp-text-secondary transition-colors hover:text-pp-text-primary"
                onClick={() => {
                  void router.push(
                    `/${position.position_post.user_name}/posts/${position.position_post.post_id}`,
                  );
                }}
              >
                <img
                  src={
                    position.position_post?.user_avatar || DEFAULT_AVATAR_URL
                  }
                  alt={position.position_post.name}
                  className="size-4 rounded-full"
                />
                <span className="line-clamp-1 md:line-clamp-none">
                  {position.position_post.name}
                </span>
              </button>
            )} */}
          <div className="mt-0.5 flex flex-col gap-1 text-xs text-pp-text-secondary">
            <div className="flex flex-wrap items-center gap-1">
              <span>取得価格:</span>
              <span>
                {formatCurrency({
                  value: position.entry_price,
                  supportZero: false,
                  withSign: false,
                  currency: position.symbol_currency || '',
                })}
              </span>
            </div>
            <div className="flex items-center gap-1">
              <span>現在価格:</span>
              <span>
                {formatCurrency({
                  value: position.current_price,
                  supportZero: false,
                  withSign: false,
                  currency: position.symbol_currency || '',
                })}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="flex items-center gap-3">
        <div className="flex flex-col text-right">
          <div
            className={cn(
              'text-xs font-semibold md:text-base',
              colorByValue(
                parseFloat(position.unrealized_pnl),
                'text-pp-text-primary',
              ),
            )}
          >
            {formatCurrency({
              value: position.unrealized_pnl,
              supportZero: true,
              withSign: true,
              currency: 'JPY',
            })}
          </div>
          <div
            className={cn(
              'mt-0.5 text-2xs md:text-xs',
              colorByValue(
                parseFloat(position.unrealized_pnl),
                'text-pp-text-secondary',
              ),
            )}
          >
            (
            {formatPercent({
              value: position.unrealized_pnl_pct,
              supportZero: true,
              withSign: true,
            })}
            )
          </div>
        </div>
        <Button
          className="w-fit bg-pp-bg-tertiary px-3 py-2 text-xs shadow-sm hover:scale-105 hover:opacity-80 hover:shadow-md md:px-4 md:text-[13px]"
          variant="outlineDefault"
          onClick={handleClick}
        >
          決済
        </Button>
      </div>
    </div>
  );
};

export default PortfolioPositionItem;
